<!-- 
    描述：审计任务、审计管理查看页
    时间： 2021-07-05
    Created by zl
-->
<template>
	<div class="audit-look-layout">
		<div class="right-btns"
			 v-show="auditVisble && routeQuery.type != 'viewClose' && routeQuery.type != 'viewApproval'">
			<el-button size="mini"
					   type="primary"
					   @click="auditShow">审核</el-button>
			<el-button size="mini"
					   @click="backApproval">取消</el-button>
		</div>
		<el-card v-for="(item, index) in cardList"
				 :key="'card' + index"
				 class="info-card">
			<!-- 标题 -->
			<div slot="header"
				 class="info-card-header"
				 @click="item.showContent = !item.showContent">
				<span class="card-header-icon">
					<i :class="item.showContent ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
				</span>
				<span>{{ `#${index + 1} ${item.title}` }}</span>
			</div>
			<!-- 内容 -->
			<div class="info-content pdt10"
				 v-show="item.showContent">
				<!-- 委托任务信息 -->
				<template v-if="item.attr === 'entrustInfo'">
					<el-form ref="sectionForm"
							 :model="sectionForm"
							 label-width="200px"
							 size="small">
						<el-row>
							<el-col :span="12">
								<el-form-item label="工程项目名称：">
									<div class="text-overflow-by"
										 @click="jumpProject">
										<div v-if="$route.query.menu != 'approval'">
											{{ $route.query.menu == 'commission' ? currentRow.sname : currentRow.proName }}
											<!-- <TextTooltip :content="currentRow.sname"
														 :refName="'currentRowSname'"
														 v-if="$route.query.menu == 'commission'"
														 class="blue-text"></TextTooltip>
											<TextTooltip :content="currentRow.proName"
														 :refName="'currentRowProName'"
														 v-else
														 class="blue-text"></TextTooltip> -->
										</div>
										<div v-else>
											{{ currentRow.projectName }}
											<!-- <TextTooltip :content="currentRow.projectName"
														 :refName="'currentRowProjectName'"
														 class="blue-text"></TextTooltip> -->
										</div>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目类型：">
									<div class="text-overflow-by">
										<span v-if="$route.query.menu != 'commission'">
											{{ currentRow.proTypeName || "暂无" }}
										</span>
										<span v-else>{{ currentRow.proType || "暂无" }}</span>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段编号：">
									<div class="text-overflow-by">
										{{ sectionForm.packNo || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段名称：">
									<div class="text-overflow-by">
										{{ sectionForm.sname }}
										<!-- <TextTooltip :content="sectionForm.sname"
													 :refName="'sectionFormSname'"></TextTooltip> -->
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段(包)类型：">
									<div class="text-overflow-by">
										{{ sectionForm.packTypeName || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="合同工期：">
									<div class="text-overflow-by">
										{{ sectionForm.duration + " 天" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目标段负责人：">
									<div class="text-overflow-by">
										{{ sectionForm.packPrincipalName || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段负责人联系方式：">
									<div class="text-overflow-by">
										{{ sectionForm.constract || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段预算金额：">
									<div class="text-overflow-by">
										{{ sectionForm.bugetValue + " 万元" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段建安工程概算价：">
									<div class="text-overflow-by">
										{{ sectionForm.estimatePriceValue + " 万元" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="招标控制价：">
									<div class="text-overflow-by">
										{{ sectionForm.controlPriceValue + " 万元" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="预备金/暂列金：">
									<div class="text-overflow-by">
										{{ sectionForm.reservePriceValue + " 万元" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="合同价：">
									<div class="text-overflow-by">
										{{ sectionForm.contractPriceValue + " 万元" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="中标价：">
									<div class="text-overflow-by">
										{{ sectionForm.bidPriceValue + " 万元" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段(包)内容建设与规模：">
									<!-- <TextTooltip :content="sectionForm.content"
												 :refName="'sectionFormContent'"></TextTooltip> -->
									<p class="break-word">{{ sectionForm.content }}</p>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="备注说明：">
									<!-- <TextTooltip :content="sectionForm.remark"
												 :refName="'sectionFormRemark'"></TextTooltip> -->
									<p class="break-word">{{ sectionForm.remark }}</p>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="关联单位：">
									<TextTooltip :content="sectionForm.relateUnitsName"
												 :refName="'sectionFormRelateUnitsName'"></TextTooltip>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</template>

				<!-- 委托报审内容 -->
				<template v-if="item.attr === 'entrustContent'">
					<el-form ref="reportForm"
							 :model="reportForm"
							 label-width="200px"
							 size="small">
						<el-row>
							<el-col :span="12">
								<el-form-item label="审计任务类型：">
									<div class="text-overflow-by">
										{{ reportForm.taskTypeName }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="委托方式：">
									<div class="text-overflow-by">
										{{
                                            reportForm.entrustType === 1
                                                ? "委托审计机关"
                                                : "自行委托"
                                        }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="'委托' + reportForm.unitTypeName + '：'">
									<div class="text-overflow-by">
										{{ reportForm.unitName }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="审计单位类型：">
									<div class="text-overflow-by">
										{{ reportForm.unitTypeName }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12"
									v-if="reportForm.taskType === '1006004002'">
								<el-form-item label="结算报审价：">
									<div class="text-overflow-by">
										{{ reportForm.auditPrice || 0 }}万元
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12"
									v-if="reportForm.confiymTypeName != ''">
								<el-form-item label="协审单位确定方式：">
									<div class="text-overflow-by">
										{{ reportForm.confiymTypeName }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="审计要求完成时间：">
									<div class="text-overflow-by"
										 v-if="reportForm.finishTime && reportForm.finishTime != ''">
										{{ reportForm.finishTime.slice(0,10) || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="标段状态：">
									<div class="text-overflow-by">
										{{ dealStatus(reportForm.status) }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="dealTitle(reportForm.status)">
									<div class="text-overflow-by"
										 v-if="reportForm.completeTime && reportForm.completeTime != ''">
										{{ reportForm.completeTime.slice(0,10) || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12"
									v-if="reportForm.taskType === '1006004002'">
								<el-form-item label="是否有甩项：">
									<div class="text-overflow-by">
										{{ reportForm.hasJilt ? '是' : '否' }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12"
									v-if="reportForm.taskType === '1006004002' && reportForm.hasJilt == 1">
								<el-form-item label="甩项金额：">
									<div class="text-overflow-by">
										{{ reportForm.jiltAmount + '元' }}
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="备注：">
									<div style="word-break: break-all">
										{{ reportForm.remark || "暂无" }}
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</template>

				<!-- 委托报审资料 -->
				<template v-if="item.attr === 'projectData'">
					<vxe-table align="center"
							   auto-resize
							   border
							   :data="reportFileData"
							   resizable
							   row-id="id"
							   ref="reportTable"
							   highlight-current-row
							   highlight-hover-row
							   :loading="reportLoading"
							   show-overflow="tooltip"
							   show-header-overflow="tooltip"
							   :tree-config="{children: 'children', expandAll: true}">
						<vxe-table-column field="sname"
										  title="资料清单"
										  tree-node
										  header-align="center"
										  align="left"
										  min-width="500">
							<template #default="{ row }">
								<i v-if="row.pid == '0'"
								   class="el-icon-folder-opened mr5"></i>
								<i v-else
								   class="el-icon-tickets mr5"></i>
								<el-tooltip effect="dark"
											:content="row.remark"
											:disabled="row.pid == 0 || row.level == 1"
											placement="top">
									<span>{{ row.sname }}</span>
								</el-tooltip>
							</template>
						</vxe-table-column>
						<vxe-table-column field="fileList"
										  title="资料名称"
										  header-align="center"
										  align="left"
										  min-width="600px">
							<template #default="{ row }">
								<div class="overflow-x">
									<span v-for="(item,index) in row.fileList"
										  :key="item.id"
										  class="blue-text vxe-cell--label">
										<FileName :fileName="item.fileName"
												  :filePath="item.filePath"
												  :fileSize="item.fileSize"></FileName>
										{{ index === row.fileList.length-1 ? '' : ',' }}
									</span>
								</div>
							</template>
						</vxe-table-column>
					</vxe-table>
				</template>

				<!-- 委托单位信息 -->
				<template v-if="item.attr === 'unitInfo'">
					<div v-for="(item, index) in entrustList"
						 :key="'entrustList' + index"
						 class="entrust-box">
						<el-row>
							<el-col :span="12">
								<el-col :span="8"
										class="text-right">{{ dealSubType(item.subType) }}：</el-col>
								<el-col :span="16"
										class="blue-text noPointer">{{ item.unitName }}</el-col>
							</el-col>
							<el-col :span="12">
								<el-col :span="8"
										class="text-right">
									<p v-if="item.subType == '1'">委托审计任务编号：</p>
									<p v-else-if="item.subType == '2'">审计单位任务编号：</p>
									<p v-else-if="item.subType == '3'">协审单位任务编号：</p>
								</el-col>
								<el-col :span="16">
									<p>{{ item.orderNo }}</p>
								</el-col>
							</el-col>
							<el-col :span="12">
								<el-col :span="8"
										class="text-right">
									{{ item.subType == "1" ? "报审日期" : "受理日期" }}：
								</el-col>
								<el-col :span="16">
									{{ item.subType == "1" ? item.taskEntrustDate : item.taskAcceptDate }}
								</el-col>
							</el-col>
							<el-col :span="12">
								<el-col :span="8"
										class="text-right">审计任务类型：</el-col>
								<el-col :span="16">{{ item.auditTypeName }}</el-col>
							</el-col>
							<el-col :span="12">
								<el-col :span="8"
										class="text-right">
									<p v-if="item.subType == '1'">建设单位任务负责人：</p>
									<p v-else-if="item.subType == '2'">审计机关主审：</p>
									<p v-else-if="item.subType == '3'">协审单位任务负责人：</p>
								</el-col>
								<el-col :span="16">
									{{ item.taskPrincipal }}
								</el-col>
							</el-col>
							<el-col :span="12">
								<el-col :span="8"
										class="text-right">
									<span v-if="item.subType == '2'">主审人联系方式</span>
									<span v-else>任务负责人联系方式：</span>
								</el-col>
								<el-col :span="16">
									{{ item.constract }}
								</el-col>
							</el-col>
						</el-row>
					</div>
				</template>

				<!-- 结项信息 -->
				<template v-if="item.attr == 'overInfo'">
					<el-form ref="overInfoform"
							 :model="overInfoform"
							 size="small"
							 label-width="200px">
						<el-row>
							<el-col :span="24">
								<el-form-item label="关联任务：">
									{{ overInfoform.taskName }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="所属合同：">
									{{ overInfoform.contractName }}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="项目归档：">
									已归档
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="结项类型：">
									{{ overInfoform.endType ? '强制结项' : '正常结项'}}
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="结项意见：">
									{{ overInfoform.remark }}
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</template>

				<!-- 审核信息 -->
				<template v-if="item.attr == 'checkInfo'">
					<vxe-table align="center"
							   border
							   class="mt15"
							   :data="auditList"
							   highlight-current-row
							   highlight-hover-row
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-table-column field="userName"
										  title="审批人/移交人"></vxe-table-column>
						<vxe-table-column field="shortName"
										  title="审批单位"
										  header-align="center"
										  align="left">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.deptName"
											placement="top">
									<span class="vxe-cell--label">{{ row.shortName }}</span>
								</el-tooltip>
							</template>
						</vxe-table-column>
						<vxe-table-column field="handleDate"
										  title="审批时间/移交时间">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.handleDate"
											:disabled="row.handleDate == ''"
											placement="top">
									<span class="vxe-cell--label"
										  v-if="row.handleDate">
										{{ row.handleDate.substr(0, 11) }}
									</span>
									<span v-else>-</span>
								</el-tooltip>
							</template>
						</vxe-table-column>
						<vxe-table-column field="status"
										  title="审批结果">
							<template #default="{ row }">
								<span v-if="row.status == '1001026002'">通过</span>
								<span v-else-if="row.status == '1001026003'">驳回</span>
								<span v-else>-</span>
							</template>
						</vxe-table-column>
						<vxe-table-column field="remark"
										  title="审批意见"
										  header-align="center"
										  align="left"></vxe-table-column>
						<vxe-table-column field=""
										  title="备注">
							<template #default="{ row }">
								<span v-if="row.status == '1001026041'">移交</span>
								<span v-else>-</span>
							</template>
						</vxe-table-column>
					</vxe-table>
				</template>
			</div>
		</el-card>

		<!-- 审核弹窗 -->
		<el-dialog :title="auditObj.title"
				   :visible.sync="auditObj.show"
				   :before-close="auditCancel"
				   :close-on-click-modal="false"
				   width="800px"
				   append-to-body
				   center>
			<el-form :model="auditObj"
					 label-width="120px"
					 ref="auditForm"
					 size="small">
				<el-row>
					<el-col :span="12">
						<el-form-item label="审核结果"
									  prop="status"
									  :rules="requireRule">
							<el-radio-group v-model="auditObj.status"
											@change="radioChange">
								<el-radio label="1001026002">通过</el-radio>
								<el-radio label="1001026003">驳回</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12"
							v-if="this.routeQuery.type != 'close'">
						<p style="margin:12px 0px;color:blue">
							备注：驳回，必须在审核意见内填写驳回理由</p>
					</el-col>
				</el-row>
				<el-form-item label="异常原因"
							  prop="reasons"
							  v-if="auditObj.status == '1001026002' && this.routeQuery.type == 'entrust'">
					<el-select v-model="auditObj.reasons"
							   placeholder="请选择"
							   clearable
							   :disabled="currentRow.reasons != ''">
						<el-option v-for="item in projectDict.ycyy"
								   :key="item.value"
								   :label="item.sname"
								   :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="审核意见"
							  prop="remark"
							  :rules="auditObj.status == '1001026003' ? requireRule : []"
							  class="mb30">
					<el-input type="textarea"
							  :autosize="{ minRows: 6 }"
							  :maxlength="200"
							  show-word-limit
							  placeholder="请输入内容"
							  v-model="auditObj.remark">
					</el-input>
				</el-form-item>
				<el-form-item v-if="this.routeQuery.type == 'close'">
					<div class="tip-box">
						<p><i class="el-icon-warning"></i>备注：驳回，必须在审核意见内填写驳回理由。</p>
						<p class="left-indent">审核结束：该审批流程到此结束。</p>
						<p class="left-indent">继续提交审核：继续为该审批流程选择下一步的提交审核对象。</p>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button class="btn"
						   @click="auditCancel"
						   size="small">取消</el-button>
				<template v-if="this.routeQuery.type != 'close'">
					<el-button class="btn btn-blue"
							   size="small"
							   @click="auditConfirm"
							   :loading="btnLoading">提交</el-button>
				</template>
				<template v-else>
					<el-button class="btn btn-success"
							   size="small"
							   @click="auditConfirm"
							   :loading="btnLoading">审核结束</el-button>
					<el-button class="btn"
							   type="primary"
							   size="small"
							   :disabled="auditObj.status == '1001026003'"
							   @click="handOther"
							   :loading="btnLoading">继续提交审核</el-button>
				</template>
			</div>
		</el-dialog>

		<!-- 移交他人审核 -->
		<AuditPersonList v-if="auditPersonShow"
						 ref="AuditPersonList"
						 :rowData="currentRow"
						 doType="audit"
						 :auditForm="auditObj"
						 @closeDia="closeDia"></AuditPersonList>

	</div>
</template>
<script>
import TextTooltip from '@/views/Common/TextTooltip'
import * as ApprovalApi from 'api/approval/approval'
import * as Api from 'api/projectManage/ProjectIndex'
import * as AuditApi from 'api/audit/audit'
import VUE_CONFIG from '../../../vue.config.js'
import AuditPersonList from '@/views/Common/AuditPersonList'
import { mapState } from 'vuex'
import { previewUrl } from '../../utils/tools'
export default {
	name: 'AuditLook',
	components: {
		TextTooltip,
		AuditPersonList,
	},
	props: {},
	data() {
		return {
			// 全部的 card 数组
			cardList: [
				{
					title: '委托任务信息',
					attr: 'entrustInfo',
					showContent: true,
				},
				{
					title: '委托报审内容',
					attr: 'entrustContent',
					showContent: true,
				},
				{
					title: '委托报审资料',
					attr: 'projectData',
					showContent: true,
				},
				{
					title: '委托单位信息',
					attr: 'unitInfo',
					showContent: true,
				},
			],
			//审核
			auditObj: {
				status: '1001026002',
				remark: '',
				title: '审核',
				reasons: '',
				show: false,
			},
			// 委托任务信息
			sectionForm: {},
			// 委托报审内容
			reportForm: {},
			reportFileData: [], //委托报审资料
			reportLoading: false,
			entrustList: [], //委托信息
			overInfoform: {}, // 结项信息
			auditList: [], //审核信息列表
			btnLoading: false,
			auditPersonShow: false,
			requireRule: [{ required: true, message: '不能为空...' }],
		}
	},
	created() {
		// 获取标段信息
		this.getSingleSection()
		// 报审信息
		this.getApprovalReport()
		if (
			this.routeQuery.menu == 'auditTask' ||
			this.routeQuery.menu == 'approval'
		) {
			// 获取委托信息
			this.checkInfo()
			// 获取结项信息
			this.getCLoseItem()
		} else {
			// 获取委托信息
			this.selectEntrustInfo()
			// 获取委托报审资料
			this.getReportFile()
		}
		if (this.routeQuery.menu == 'approval') {
			if (
				this.routeQuery.type == 'viewClose' ||
				this.routeQuery.type == 'close'
			) {
				this.cardList.push(
					{
						title: '结项信息',
						attr: 'overInfo',
						showContent: true,
					},
					{
						title: '审核信息',
						attr: 'checkInfo',
						showContent: true,
					}
				)
			} else {
				this.cardList.push({
					title: '审核信息',
					attr: 'checkInfo',
					showContent: true,
				})
			}
		}
		// 获取审批信息
		this.getApprovalList()
        this.auditObj.reasons = this.currentRow.reasons || ''
	},
	methods: {
		// 移交其他人员
		handOther() {
			this.auditPersonShow = true
			this.$refs.auditForm.validate((valid) => {
				if (valid) {
					setTimeout(() => {
						this.$refs.AuditPersonList.auditPersonObj.show = true
					}, 200)
					return
				}
				this.$message.error('请完善表单！')
			})
		},

		// 接收弹窗关闭
		closeDia(data) {
			this.auditPersonShow = false
			if (data) {
				this.backApproval()
			}
		},

		// change事件
		radioChange(data) {
			setTimeout(() => {
				this.$refs.auditForm.clearValidate()
			}, 100)
		},

		// 获取审批信息
		getApprovalList() {
			ApprovalApi.selectApproveRecordById({
				id: this.currentRow.id,
				module: 3,
			}).then((res) => {
				this.auditList = res.data
			})
		},

		//审核取消
		auditCancel() {
			this.auditObj.show = false
			this.$refs.auditForm.resetFields()
		},

		//审核提交
		auditConfirm() {
			this.$refs.auditForm.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					let params = Object.assign({}, this.auditObj)
					params.busId = this.currentRow.busId
					if (params.status == '1001026003') {
						delete params.reasons
					}
					ApprovalApi.getSubmitAdd(params).then((res) => {
						if (res.operationCode != 1 || res.msg == 'faild') {
							this.btnLoading = false
							this.$message.error(res.data)
							return
						}
						this.btnLoading = false
						this.$router.push({ path: '/approval' })
					})
					return
				}
				this.$message.error('请完善表单！')
			})
		},

		// 获取结项信息
		getCLoseItem() {
			if (
				this.routeQuery.type == 'close' ||
				this.routeQuery.type == 'viewClose'
			) {
				Api.getCloseItemByTaskId({
					busId: this.currentRow.busId,
					recordId: this.currentRow.id,
				}).then((res) => {
					this.overInfoform = res.data
				})
			}
		},

		// 获取标段信息
		getSingleSection() {
			let params = {}
			params.packId = this.currentRow.packId
			ApprovalApi.getSectionInfo(params).then((res) => {
				this.sectionForm = res.data
			})
		},

		// 点击工程项目名称 跳转查看工程项目信息
		jumpProject() {
			let queryParams = {
				menu: 'project',
				type: 'view',
			}

			queryParams.projectId = this.currentRow.projectId
			this.$router.push({
				path: '/projectInfoLook',
				query: queryParams,
			})
		},

		// 报审信息
		getApprovalReport() {
			let taskId = ''
			this.routeQuery.menu == 'commission'
				? (taskId = this.currentRow.id)
				: (taskId = this.currentRow.pid)
			if (this.routeQuery.menu == 'approval') {
				taskId = this.currentRow.busId
			}
			Api.busTaskInfo({
				taskId: taskId,
			}).then((res) => {
				this.reportForm = res.data
			})
		},

		// 获取委托报审资料
		getReportFile(data) {
			this.reportLoading = true
			let taskId = ''
			this.routeQuery.menu == 'commission'
				? (taskId = this.currentRow.id)
				: (taskId = this.currentRow.pid)
			if (this.routeQuery.menu == 'approval') {
				taskId = this.currentRow.busId
			}
			if (data) {
				taskId = data
			}
			Api.getReportFiles({
				taskId: taskId,
				type: '1',
			})
				.then((res) => {
					this.reportFileData = res.data
					this.reportLoading = false
					let templateId = res.data[0].templateId
					this.reportFileData = this.$utils.mapTree(
						this.reportFileData,
						(item) => {
							if (item.pid == templateId) {
								item.level = 1
							}
							return item
						}
					)
				})
				.catch(() => {
					this.reportLoading = false
				})
		},

		// 校验pid
		checkInfo() {
			if (this.currentRow.entrustType == 1) {
				Api.getOwnerTaskId({
					id: this.currentRow.pid,
				}).then((res) => {
					// 获取委托信息
					this.selectEntrustInfo(res.data.pid)
					// 获取委托报审资料
					this.getReportFile(res.data.pid)
				})
			} else {
				// 获取委托信息
				this.selectEntrustInfo()
				// 获取委托报审资料
				this.getReportFile()
			}
		},

		// 获取委托信息
		selectEntrustInfo(data) {
			let taskId = ''
			this.routeQuery.menu == 'commission'
				? (taskId = this.currentRow.id)
				: (taskId = this.currentRow.pid)
			if (this.routeQuery.menu == 'approval') {
				taskId = this.currentRow.busId
			}
			if (data) {
				taskId = data
			}
			AuditApi.selectEntrustInfo({
				packId: this.currentRow.packId,
				statusSign: '1',
				taskId: taskId,
				auditType: this.currentRow.auditType,
			}).then((res) => {
				this.entrustList = res.data
			})
		},

		// 预览图片
		doView(data) {
			let uploadUrl = ''
			// 本地环境代理后无法直接获取路径
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}

			window.open(this.$previewUrl + previewUrl(uploadUrl + data.filePath), '_blank')
		},

		// 处理label
		dealTitle(status, data) {
			let msg = ''
			if (
				this.reportForm.taskTypeName == '结算审计' ||
				data == '结算审计'
			) {
				status == 0
					? (msg = '计划竣工时间：')
					: (msg = '实际竣工时间：')
			} else {
				// 标段状态  0：未竣工  1：已竣工
				status == 0
					? (msg = '计划开工时间：')
					: (msg = '实际开工时间：')
			}
			return msg
		},

		//处理状态
		dealStatus(data, item) {
			let msg = ''
			if (
				this.reportForm.taskTypeName == '结算审计' ||
				item == '结算审计'
			) {
				// 标段状态  0：未竣工  1：已竣工
				data == 0 ? (msg = '未竣工') : (msg = '已竣工')
			} else {
				// 标段状态  0：未开工  1：已开工
				data == 0 ? (msg = '未开工') : (msg = '已开工')
			}
			return msg
		},

		// 处理类型
		dealSubType(type) {
			let msg = ''
			switch (type) {
				case '1':
					msg = '建设单位'
					break
				case '2':
					msg = '委托审计单位'
					break
				case '3':
					msg = '委托协审单位'
					break
				default:
					msg = ''
			}
			return msg
		},

		//展示审核
		auditShow() {
			this.auditObj.show = true
		},

		// 取消
		backApproval() {
			this.$router.push({ path: '/redirect/approval' })
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		// 缓存的当前行对象
		currentRow() {
			return this.$getSessionItem('currentRow')
				? JSON.parse(this.$getSessionItem('currentRow'))
				: {}
		},
		routeQuery() {
			return this.$route.query
		},
		//审核按钮可见
		auditVisble() {
			return this.$route.query.menu === 'approval'
		},
	},
	beforeRouteLeave(to, from, next) {
		this.$getSessionItem('currentRow')
			? this.$removeSessionItem('currentRow')
			: ''
		if (
			to.path == '/redirect/auditTask' ||
			to.path == '/redirect/auditManagement' ||
			to.path == '/redirect/approval'
		) {
		} else {
			this.$getSessionItem('activeName')
				? this.$removeSessionItem('activeName')
				: ''
		}
		next()
	},
}
</script>
<style lang='less' scoped>
.audit-look-layout {
	height: 100%;
	padding: 20px;
	overflow-y: auto;
	.el-form-item {
		margin-bottom: 5px !important;
	}
	.blue-text {
		color: #2671cc;
	}
	.entrust-box {
		border: 1px solid #eee;
		margin-bottom: 15px;
		.el-col-12 {
			display: flex;
			align-items: center;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			border-bottom: 1px solid #e9e9e9;
		}
		.el-col-12:last-child,
		.el-col-12:nth-last-child(2) {
			border-bottom: none;
		}
		.el-col-8 {
			height: 100%;
			background-color: #f7f7f7;
			padding-right: 5px;
		}
		.el-col-16 {
			height: 100%;
			padding-left: 10px;
			border-left: 1px solid #e9e9e9;
			border-right: 1px solid #e9e9e9;
		}
	}
	.noPointer {
		cursor: default;
	}
	.right-btns {
		position: absolute;
		right: 0;
		top: 66px;
		padding: 0 10px;
		background-color: #fff;
		z-index: 10;
	}
}
.overflow-x {
	overflow-x: auto;
}
.btn {
	padding: 0 50px !important;
}
.break-word {
	word-break: break-all;
}
.tip-box {
	line-height: 25px;
	background: #ecf5ff;
	border-radius: 5px;
	border: 1px solid #d9ecff;
	color: #419eff;
	padding: 5px 15px;
	.left-indent {
		text-indent: 3.5rem;
	}
}
</style>
